import { render, staticRenderFns } from "./ChooseService.vue?vue&type=template&id=5604f691&scoped=true"
import script from "./ChooseService.vue?vue&type=script&lang=ts"
export * from "./ChooseService.vue?vue&type=script&lang=ts"
import style0 from "./ChooseService.vue?vue&type=style&index=0&id=5604f691&prod&scoped=true&lang=scss"
import style1 from "./ChooseService.vue?vue&type=style&index=1&id=5604f691&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5604f691",
  null
  
)

export default component.exports